module.exports = __webpack_public_path__ + "static/media/missionImg.e50ae2d9.png";